import {useEffect, useMemo, useState} from "react";

export function useOnScreen(ref, isVisibleDefault = false) {

  const [isIntersecting, setIntersecting] = useState(isVisibleDefault)

  const observer = useMemo(() => new IntersectionObserver(
    ([entry]) => setIntersecting(entry.isIntersecting)
  ), [ref])


  useEffect(() => {
    if(ref.current)
      observer.observe(ref.current)
    return () => observer.disconnect()
  }, [])

  return isIntersecting
}